/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UserService from "../../services/userService";
import { Box, Button, CircularProgress, Typography, useMediaQuery } from "@mui/material";
import UpdateImageUpload from "../../components/inputs/uploadImageUpdate";
import CustomInput from "../../components/inputs/customInput";
import { fileApiRoute } from "../../services/networkService";
import StatusDropdown from "../../components/dropdowns/statusDropdown";
import BranchDropdown from "../../components/dropdowns/branchDropdown";
import RoleDropdown from "../../components/dropdowns/roleDropdown";
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { useTheme } from "@emotion/react";
import Popup from "../../components/popups/popup";
import { useNavigate, useParams } from "react-router-dom";
import UserTypeDropdown from "../../components/dropdowns/userTypeDropdown";

const UpdateUser = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const { id } = useParams();

    const [user, setUser] = useState({});
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedIDImage, setSelectedIDImage] = useState(null);

    const [formValues, setFormValues] = useState({
        name: user.name,
        phone: user.phone,
        phoneTwo: user.phoneTwo,
        password: '',
        confirmPassword: '',
        note: user.note,
        printerName: user.printerName,
        roleId: user.roleId,
        branchId: user.branchId,
        status: user.status,
        type: user.type,
        deleteImage: false,
        deleteIDImage: false
    });

    const [updateErrors, setUpdateErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(true);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleImageChange = (file) => {
        setSelectedImage(file);
    };

    const handleIDImageChange = (file) => {
        setSelectedIDImage(file);
    };

    const validateForm = () => {
        const newAUpdateErrors = {};

        if (formValues.password && formValues.password.length < 8) {
            newAUpdateErrors.password = t('passwordMin');
        }

        if (formValues.password !== formValues.confirmPassword) {
            newAUpdateErrors.confirmPassword = t('confirmPasswordMatch');
        }

        setUpdateErrors(newAUpdateErrors);

        return Object.keys(newAUpdateErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm()) {
            try {
                setIsLoading(true);
                const formData = new FormData();

                for (const key in formValues) {
                    if (formValues[key] && formValues[key] !== '')
                        formData.append(key, formValues[key]);
                }

                if (selectedImage) {
                    formData.append('image', selectedImage);
                }

                if (selectedIDImage) {
                    formData.append('IDImage', selectedIDImage);
                }

                const data = await UserService.update(id, formData);
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('success');
                    setShowPopup(true);
                    navigate('/users');
                    // setTimeout(() => {

                    // }, 3000);
                }

                setUpdateErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setUpdateErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setUpdateErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    const fetchUser = async () => {
        try {
            const data = await UserService.fetchOne(id);
            setUser(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching user:', error);
        }
    };

    useEffect(() => {
        if (user) {
            setFormValues({
                name: user.name || '',
                phone: user.phone || '',
                phoneTwo: user.phoneTwo || '',
                note: user.note || '',
                printerName: user.printerName || '',
                roleId: user.roleId || '',
                branchId: user.branchId || '',
            });
            setSelectedRole(user.role || null);
            setSelectedBranch(user.branch || null);
            setSelectedStatus(t(user.status) || '');
            setSelectedType(t(user.type) || '');
            setUpdateErrors({});
        }
    }, [user]);


    useEffect(() => {
        setIsModalLoading(true);
        fetchUser();
    }, []);



    return (
        <Box sx={{
            p: isTablet ? 1 : 2,
            backgroundColor: theme.palette.secondary.main,
        }}>
            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}

            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    p: isTablet ? 2 : 4
                }}
            >
                {
                    isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('updateUser')}
                                </Typography>
                            </Box>

                            {/* row 1 */}
                            <Box sx={{
                                display: isTablet ? 'unset' : 'flex',
                                justifyContent: 'space-between'
                            }}>
                                {/* role */}
                                <Box width={isTablet ? '100%' : '32%'}>
                                    <RoleDropdown
                                        helperText={updateErrors.role}
                                        error={!!updateErrors.role}
                                        setFormValues={setFormValues}
                                        isFilter={false}
                                        selectedRole={selectedRole}
                                        setSelectedRole={setSelectedRole}
                                        disableSuperAdmin={true}
                                    />
                                </Box>

                                {/* Branch */}
                                <Box width={isTablet ? '100%' : '32%'}>
                                    <BranchDropdown
                                        helperText={updateErrors.branch}
                                        error={!!updateErrors.branch}
                                        setFormValues={setFormValues}
                                        isFilter={false}
                                        selectedBranch={selectedBranch}
                                        setSelectedBranch={setSelectedBranch}
                                    />
                                </Box>

                                {/* Type */}
                                <Box width={isTablet ? '100%' : '32%'}>
                                    <UserTypeDropdown
                                        helperText={updateErrors.type}
                                        error={!!updateErrors.type}
                                        setFormValues={setFormValues}
                                        isFilter={false}
                                        selectedType={selectedType}
                                        setSelectedType={setSelectedType}
                                    />
                                </Box>
                            </Box>


                            {/* row 2 */}
                            <Box sx={{
                                display: isTablet ? 'unset' : 'flex',
                                justifyContent: 'space-between'
                            }}>
                                {/* Status */}
                                <Box width={isTablet ? '100%' : '32%'}>
                                    <StatusDropdown
                                        helperText={updateErrors.status}
                                        error={!!updateErrors.status}
                                        setFormValues={setFormValues}
                                        isFilter={false}
                                        selectedStatus={selectedStatus}
                                        setSelectedStatus={setSelectedStatus}
                                    />
                                </Box>

                                <Box width={isTablet ? '100%' : '32%'}>
                                    <CustomInput
                                        label={t('name')}
                                        placeholder={t('nameHere')}
                                        name="name"
                                        type='text'
                                        value={formValues.name}
                                        error={!!updateErrors.name}
                                        helperText={updateErrors.name}
                                        onChange={handleChange}
                                    />
                                </Box>

                                <Box width={isTablet ? '100%' : '32%'}>
                                    <CustomInput
                                        label={t('phone')}
                                        placeholder={t('phoneHere')}
                                        name="phone"
                                        type='text'
                                        value={formValues.phone}
                                        error={!!updateErrors.phone}
                                        helperText={updateErrors.phone}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>


                            {/* row 3 */}
                            <Box sx={{
                                display: isTablet ? 'unset' : 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <Box width={isTablet ? '100%' : '32%'}>
                                    <CustomInput
                                        label={t('phoneTwo')}
                                        placeholder={t('phoneTwoHere')}
                                        name="phoneTwo"
                                        type='text'
                                        value={formValues.phoneTwo}
                                        onChange={handleChange}
                                    />
                                </Box>

                                <Box width={isTablet ? '100%' : '32%'}>
                                    <CustomInput
                                        label={t('password')}
                                        placeholder="******"
                                        name="password"
                                        type="password"
                                        value={formValues.password}
                                        onChange={handleChange}
                                        error={!!updateErrors.password}
                                        helperText={updateErrors.password}
                                    /></Box>

                                <Box width={isTablet ? '100%' : '32%'}>
                                    <CustomInput
                                        label={t('confirmPassword')}
                                        placeholder="******"
                                        name="confirmPassword"
                                        type="password"
                                        value={formValues.confirmPassword}
                                        onChange={handleChange}
                                        error={!!updateErrors.confirmPassword}
                                        helperText={updateErrors.confirmPassword}
                                    /></Box>
                            </Box>

                            <Box sx={{
                                display: isTablet ? 'unset' : 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <Box width={isTablet ? '100%' : '48%'}>
                                    <CustomInput
                                        label={t('printerName')}
                                        placeholder={t('printerNameHere')}
                                        name="printerName"
                                        type='text'
                                        value={formValues.printerName}
                                        onChange={handleChange}
                                    />
                                </Box>

                                <Box width={isTablet ? '100%' : '48%'}>
                                    <CustomInput
                                        label={t('note')}
                                        placeholder={t('noteHere')}
                                        name="note"
                                        type='text'
                                        value={formValues.note}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>

                            {/* images */}
                            <Box
                                sx={{
                                    display: isTablet ? 'unset' : 'flex',
                                    justifyContent: 'space-around',
                                    width: '100%'
                                }}>
                                <Box sx={{ width: isTablet ? '100%' : '30vw' }}>
                                    <UpdateImageUpload
                                        label={t('uploadImage')}
                                        name={t('image')}
                                        value={'deleteImage'}
                                        onChange={handleImageChange}
                                        image={`${fileApiRoute}/${user.image}`}
                                        setFormValues={setFormValues}
                                    />
                                </Box>

                                <Box sx={{ width: isTablet ? '100%' : '30vw' }}>
                                    <UpdateImageUpload
                                        label={t('uploadIDImage')}
                                        name={t('IDimage')}
                                        value={'deleteIDImage'}
                                        onChange={handleIDImageChange}
                                        image={`${fileApiRoute}/${user.IDImage}`}
                                        setFormValues={setFormValues}
                                    />
                                </Box>

                            </Box>


                            {updateErrors.general && (
                                <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                                    {updateErrors.general}
                                </Typography>
                            )}

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: updateErrors.general ? 2 : 4
                            }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                >
                                    {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <p>{t('update')}</p>
                                            <DriveFileRenameOutlineOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                        </Box>
                                    }
                                </Button>
                            </Box>
                        </Box>
                }

            </Box>
        </Box>
    );
}

export default UpdateUser;